<div class="inbound-step-content">
  <sg-text class="inbound-title" color="decorative-text-01" variant="sg-p4-big-paragraph">Inbound Folder</sg-text>
  <sg-text class="inbound-description" color="text-secondary" variant="sg-p3-standard">
    You chose to investigate the Inbound folder, since your file wasn’t found in the Outbound folder. Here’s a list of files that were received but not
    processed during last 24 hours.
    <span style="font-weight: bold">Do you see your file below?</span>
  </sg-text>
  <sg-inspector-files-table
    #inspectorTable
    [columns]="inboundColumns"
    [tableData$]="inboundTableData$"
    [fileContent$]="inboundFileContent$"
    (onClickRow)="onClickRow.emit($event)"
    (onClickDownloadFile)="onClickDownloadFile.emit($event)">
    <div id="ngrid-definitions">
      <div *pblNgridCellDef="'status'; row as row">
        <div>
          @switch (swiftStatusMapper[row.status]) { @case ('processedFailure') {
          <div>
            <sg-text class="status-text" [variant]="'sg-p1-small-letters'" color="text-error">
              <mat-icon>sg-warning_amber</mat-icon>
              processing failure
            </sg-text>
          </div>
          } @case ('notProcessed') {
          <div>
            <sg-text class="status-text" [variant]="'sg-p1-small-letters'" color="text-placeholder">
              <mat-icon>remove_circle_outline</mat-icon>
              not processed
            </sg-text>
          </div>
          } @default {
          <div>Unknown status</div>
          } }
        </div>
      </div>
    </div>
    @if (inspectorTable.selectedFile?.failureReason) {
    <div id="file-details-container" class="file-details-container">
      <sg-text variant="sg-p2" color="text-tertiary">Failure reason:</sg-text>
      <sg-text variant="sg-p2" color="text-primary">{{inspectorTable.selectedFile?.failureReason}}</sg-text>
    </div>
    }
  </sg-inspector-files-table>
  <div class="inbound-buttons-container">
    <sg-button
      (onClick)="onClickRestart.emit()"
      size="medium"
      text="No... Restart Investigation"
      icon="sg-restart_alt"
      iconPosition="start"
      variant="secondary"></sg-button>
    <sg-button (onClick)="onClickClose.emit()" size="medium" text="Yes! Close Investigation" icon="sg_check_circle_outline" variant="primary"></sg-button>
  </div>
</div>
